module.exports = __webpack_public_path__ + "assets/img/super.82486a0b.png";